import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectLayout, THEME } from './store/layout/layoutSlice';
import { Routes } from './routes/Routes';
import { useEnhancedWhiteLabel } from './whiteLabel/hooks';

const AppContent = () => {
  useEnhancedWhiteLabel();

  const layout = useSelector(selectLayout);

  useEffect(() => {
    const isDark = document.documentElement.classList.contains('dark');
    if (layout.theme === THEME.DARK && !isDark) {
      document.documentElement.classList.add('dark');
    } else if (layout.theme !== THEME.DARK && isDark) {
      document.documentElement.classList.remove('dark');
    }
  }, [layout.theme]);

  return <Routes />;
};

export default AppContent;
